import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
import { User } from '../../../../analytics/interfaces/user.interface';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-partner-info',
	styleUrls: ['./partner-info.component.css'],
	templateUrl: './partner-info.component.html'
})
export class PartnerInfoComponent implements OnInit, AfterViewInit {
	public welcometext: string;
	public partnerLogo = '';
	public partnerName = '';

	public user: User;
	public userName = '';
	public logo = '';
	public isToggled = false;
	public isR10: boolean = false;

	constructor(private analyticsDataModel: AnalyticsDataModel) {
		EmitterService.get(EVENT_EMITTERS.TOGGLE_LAYOUT).subscribe((response: any) => {
			this.isToggled = response;
			if (this.isToggled) {
				this.logo = this.analyticsDataModel.config.partner.partnerLogoIcon;
			} else {
				this.logo = this.analyticsDataModel.config.partner.partnerLogo;
			}
			setTimeout(
				() => {
					this.processName();
				},
				this.isToggled ? 10 : 500
			);
		});
	}

	ngOnInit(): void {
		this.isR10 = this.analyticsDataModel.config.version === 'R10' ? true : false;
	}

	ngAfterViewInit(): void {
		this.user = this.analyticsDataModel.user;
		this.userName = `${this.user.firstName} ${this.user.lastName}`;
		this.partnerName = this.analyticsDataModel.partner.partnerName;
		this.partnerLogo = this.analyticsDataModel.config.partner.partnerLogo;
		this.logo = this.partnerLogo;
		this.welcometext = !this.welcometext ? 'Welcome' : this.welcometext;
	}

	processName(): void {
		if (this.isToggled) {
			this.userName = this.user.firstName[0];
		} else {
			this.userName = `${this.user.firstName} ${this.user.lastName}`;
		}
	}
}
